import { add } from 'lodash';
import { setProductConfig } from '../../../actions/v3Order';

export const getTotalPages = (shoot, additionalData) => {
  let skipPoseSelection = false;

  if (shoot.isPrepay) {
    skipPoseSelection = true;
  }

  if (additionalData?.isGeskus) {
    skipPoseSelection = true;
  }

  const skipBackgroundSelection = !shoot.isGreenScreen;
  const pages = ['product'];
  if (!skipPoseSelection) pages.push('pose');
  if (!skipBackgroundSelection) pages.push('background');
  return pages;
};

export const getNextUrl = (
  current,
  pages,
  history,
  productConfig,
  event,
  itemBeingAdded = null,
) => {
  const currentUrlIndex = pages.indexOf(current);
  const url = history.location.pathname.split('/');
  let nextUrl = pages[currentUrlIndex + 1];
  let index = parseInt(url[url.length - 1]);

  const currentProduct = productConfig[index]?.product;
  let skipsPersonalization =
    currentProduct?.personalization_status === 'no_personalization';

  // in this case, personalization will be prompted before checkout only
  if (
    event.isPrepay &&
    event.prepayPersonalizationOfferType ===
      'prepay_personalization_prompted_before_checkout_only'
  ) {
    skipsPersonalization = true;
  }

  console.log('%cskipsPersonalization: ' + skipsPersonalization, 'color: lime');
  console.log('CURRENT URL INDEX', currentUrlIndex, current);

  // Special handling for product -> productOptions transition
  if (current === 'product' && itemBeingAdded) {
    // Check if the item being added has product options
    console.log('Checking for product options on item being added:', {
      current,
      index,
      itemBeingAdded,
      hasOptionSets: itemBeingAdded.product_option_sets?.length > 0,
      hasOptions: itemBeingAdded.product_options?.length > 0,
    });

    const hasOptions =
      itemBeingAdded.product_option_sets?.length > 0 ||
      itemBeingAdded.product_options?.length > 0;

    if (hasOptions) {
      // Go to productOptions page if product has options
      console.log('Product has options, navigating to productOptions page');
      nextUrl = 'productOptions';
      const nextHash = '';
      url.splice(url.length - 2, 2);
      // For You-Pick products, always use index 0
      const optionsIndex = productConfig[0]?.products ? 0 : index;
      const result = `${url.join('/')}/${nextUrl}/${optionsIndex}${nextHash}`;
      return result;
    }
  }

  // If we're on productOptions, continue to the next page in the normal flow
  if (current === 'productOptions') {
    // Find what would have been the next page after 'product'
    const productIndex = pages.indexOf('product');
    nextUrl = pages[productIndex + 1] || pages[0];
    const nextHash = '';
    url.splice(url.length - 2, 2);
    const result = `${url.join('/')}/${nextUrl}/${index}${nextHash}`;
    return result;
  }

  if (currentUrlIndex === pages.length - 1) {
    nextUrl =
      !skipsPersonalization && !productConfig[index]?.personalization
        ? 'personalization'
        : pages[0];
    if (nextUrl !== 'personalization') index += 1;
  }

  if (currentUrlIndex < 0) index += 1;

  const nextHash = nextUrl === 'product' ? '#slots' : '';
  url.splice(url.length - 2, 2);

  const result = `${url.join('/')}/${nextUrl}/${index}${nextHash}`;
  return result;
};

const updateStackRouter = (dispatch, history) => {
  const { pathname, hash } = history.location;
  const paths = [pathname + hash];
  if (!hash && pathname.includes('/product/'))
    paths.unshift(pathname + '#slots');
  dispatch(addToConfigStack(paths));
};

export const addToConfig = ({
  dispatch,
  history,
  productConfig,
  pages,
  itemToAdd,
  event,
  cropIndex = null,
}) => {
  const { pathname, hash } = history.location;
  const currentUrlSplit = pathname.split('/');
  const current = currentUrlSplit[currentUrlSplit.length - 2];
  const index = pathname.split('/').pop().replace('#slots', '');
  let newItem = itemToAdd;

  if (cropIndex !== null && current === 'pose') {
    newItem = { ...itemToAdd };
    newItem.selected_crop = newItem.cropped_images[cropIndex];
  }

  const item = { [current]: newItem };

  if (pathname.includes('product/') && hash !== '#slots')
    item.usedSlotSelectionUi = true;

  // If we're on productOptions page, merge the options with the existing product config
  if (current === 'productOptions') {
    const existingConfig = productConfig[index] || {};

    // For You-Pick products, we need to update the specific product in the products array
    if (existingConfig.products?.length > 0) {
      // Find the last product (the one we just configured)
      const updatedProducts = [...existingConfig.products];
      const lastProductIndex = updatedProducts.length - 1;
      updatedProducts[lastProductIndex] = {
        ...updatedProducts[lastProductIndex],
        productOptions: newItem,
      };

      const mergedItem = {
        ...existingConfig,
        products: updatedProducts,
      };
      dispatch(setProductConfig({ index, itemToAdd: mergedItem, cropIndex }));
    } else {
      // Regular flow: just add productOptions to the config
      const mergedItem = { ...existingConfig, productOptions: newItem };
      dispatch(setProductConfig({ index, itemToAdd: mergedItem, cropIndex }));
    }
  } else {
    dispatch(setProductConfig({ index, itemToAdd: item, cropIndex }));
  }

  history.push(
    getNextUrl(
      current,
      pages,
      history,
      productConfig,
      event,
      current === 'product' ? newItem : null,
    ),
  );
};
